const RTL_LANGUAGES: Set<string> = new Set([
	// Arabic
	"ar",
	"ara",
	// Hebrew
	"he",
	"heb",
	// Persian (Farsi)
	"fa",
	"fas",
	// Urdu
	"ur",
	"urd",
	// Yiddish
	"yi",
	"yid",
	// Sindhi
	"sd",
	"snd",
	// Dhivehi (Maldivian)
	"dv",
	"div",
	// Kurdish (Sorani)
	"ku",
	"kur",
	// Pashto
	"ps",
	"pus",
]);

export function isRTL(language: string): boolean {
	// This doesn't work in all browsers:
	// return ((new Intl.Locale(language)) as any)?.textInfo?.direction == 'rtl';
	return RTL_LANGUAGES.has(language);
}